import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ReactionStackContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexDirection: 'row',
}))

export const ReactionCountContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  alignItems: 'center',
}))

export const ReactionIcon = styled('img')<{ index?: number }>(
  ({ index = 0, theme }) => ({
    cursor: 'pointer',
    marginLeft: index > 0 ? '-15px' : '0px',
    zIndex: index,
    border: '0.75px solid #C0C1C3',
    borderRadius: '50%',
    padding: theme.spacing(0.5),
    backgroundColor: 'white',
    transition: 'transform 0.3s ease',
  }),
)

export const ReactionCount = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  color: theme.colors.primary.slalomBlue,
  textDecoration: 'underline',
}))

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  [theme.breakpoints.up('mobile')]: {
    marginBottom: theme.spacing(2),
  },
}))

export const GridViewContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4px 8px',
})

export const GridReactionStack = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, auto)',
  gridRowGap: '16px',
  columnGap: '12px',
  justifyContent: 'center',
  alignItems: 'center',
})

export const GridReactionItem = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: 'white',
  justifyContent: 'center',
  marginRight: '24px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    cursor: 'pointer',
  },
})

export const GridReactionCount = styled('span')(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
  fontFamily: theme.typography.h3.fontFamily,
}))
